import { navigation, success } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { scrollbarBase } from '../../styles/styles';

const {
	colors,
	common: { border, borderRadius },
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		background: colors.background.light,
	},

	filtersContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '1rem',
	},

	actionsContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},

	bodyContainer: {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'auto',
		position: 'relative',
		height: '100%',
		border,
		borderRadius,
		background: colors.background.light,
		...scrollbarBase,
	},

	withFooter: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},

	summaryContainer: {
		padding: '1rem',
	},

	noResults: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '2rem',
		textAlign: 'center',
		gap: '1rem',
		flex: 1,
	},

	statsContainer: {
		position: 'sticky',
		bottom: 0,
		backgroundColor: colors.hover.light,
		display: 'flex',
		gap: 36,
		justifyContent: 'space-between',
		padding: 16,
		boxSizing: 'border-box',
		borderBottomLeftRadius: borderRadius,
		borderBottomRightRadius: borderRadius,
		border,
		borderTop: 'unset',
	},

	statHeader: {
		fontSize: '1.1rem',
		fontWeight: 600,
	},

	stat: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	filterGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem',
	},
	breadcrumbsBar: {
		display: 'flex',
		alignItems: 'center',
		gap: 24,
		paddingRight: 16,
	},

	statLabel: {
		color: navigation,
		fontSize: 12,
		fontWeight: 600,
		margin: 0,
		textTransform: 'uppercase',
	},
	statValue: {
		color: colors.primary.main,
		fontWeight: 600,
		fontSize: 18,
	},
	totalValue: {
		color: success,
		fontWeight: 600,
		fontSize: 18,
	},
	statTitle: {
		display: 'flex',
		alignItems: 'center',
		fontWeight: 600,
	},
});
